import { MessageBox, Message } from 'element-ui';

export const formatList = data => {
    if (!data.length) return [];
    data.forEach((v, index) => {
        v.tableIndex = index + 1;
        if (v.forceFlag !== null || v.forceFlag !== undefined) {
            v.forceFlag = v.forceFlag + '';
        } else {
            v.forceFlag = '';
        }
    });
    return data;
};

/**
 * @description 按钮操作 二次确认的消息提示
 * @param {Function} tipsInfo 提示信息
 * @param {String} api 调用的接口
 * @param {Array/String/Object} params 需要传递的参数
 * @param {String} successTips 操作成功的提示
 * @param {Object} that 接收函数调用者的 this
 */
export const messageTips = (tipsInfo = '此操作将永久修改该数据, 是否继续？', api, params, successTips = '操作成功', that) => {
    MessageBox.confirm(tipsInfo, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = '执行中...';
                api(params)
                    .then(res => {
                        if (res && +res.code === 0) {
                            Message.success(successTips);
                            that.getList();
                            done();
                        }
                    })
                    .catch(() => { })
                    .finally(() => {
                        instance.confirmButtonLoading = false;
                        done();
                    });
            } else {
                done();
            }
        }
    }).catch(() => { }); // 添加错误捕获
};
